import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["aria-hidden"];
const _hoisted_2 = ["xlink:href"];
import { useContext } from "@/store/context";
import { storeToRefs } from "pinia";
import { computed } from "vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    ...{ inheritAttrs: false },
    __name: 'SvgIcon',
    props: {
        icon: {},
        src: { default: "/svg/svg-defs.svg" },
        width: { default: "1.25rem" },
        height: { default: "1.25rem" },
        color: { default: "currentColor" },
        decorative: { type: Boolean, default: true }
    },
    setup(__props) {
        _useCssVars(_ctx => ({
            "5f8f4831": (_ctx.color),
            "60a64694": (_ctx.width),
            "cb58dbce": (_ctx.height)
        }));
        const props = __props;
        const contextStore = useContext();
        const { resourceTimestamp } = storeToRefs(contextStore);
        const url = computed(() => {
            return props.src + "?ts=" + resourceTimestamp.value + "#" + props.icon;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", _mergeProps(_ctx.$attrs, {
                "aria-hidden": _ctx.decorative ? 'true' : undefined
            }), [
                _createElementVNode("use", {
                    "xmlns:xlink": "http://www.w3.org/1999/xlink",
                    "xlink:href": url.value
                }, null, 8, _hoisted_2)
            ], 16, _hoisted_1));
        };
    }
});
